// check for mobile h1 first, then regular h1, then default
export const getHeadingMobileFontSize = ({
  theme,
  headingLevel,
  defaultSize,
}) =>
  theme?.fontSizes?.mobile?.[headingLevel]
    ? theme.fontSizes.mobile[headingLevel]
    : theme?.fontSizes?.[headingLevel]
      ? theme.fontSizes[headingLevel]
      : defaultSize

// since uses mobile font size func, will check in this order:
// 1. tablet h1
// 2. mobile h1
// 3. regular h1
// 4. default tablet h1
export const getHeadingTabletFontSize = ({
  theme,
  headingLevel,
  defaultSize,
}) =>
  theme?.fontSizes?.tablet?.[headingLevel]
    ? theme.fontSizes.tablet[headingLevel]
    : getHeadingMobileFontSize({ theme, headingLevel, defaultSize })

export const getHeadingDesktopFontSize = ({
  theme,
  headingLevel,
  defaultSize,
}) =>
  theme?.fontSizes?.desktop?.[headingLevel]
    ? theme.fontSizes.desktop[headingLevel]
    : getHeadingTabletFontSize({ theme, headingLevel, defaultSize })

export const getHeadingFontSize = ({ theme, headingLevel, defaultSize }) =>
  theme?.fontSizes?.[headingLevel]
    ? theme.fontSizes[headingLevel]
    : getHeadingTabletFontSize({ theme, headingLevel, defaultSize })

export const getHeadingAttrs =
  (headingLevel, defaults) =>
  ({ theme, defaultFontSizes }) => ({
    as: headingLevel,
    fontSize: [
      getHeadingMobileFontSize({
        theme,
        headingLevel,
        defaultSize: defaultFontSizes?.mobile || defaults?.fontSizes?.mobile,
      }),
      getHeadingTabletFontSize({
        theme,
        headingLevel,
        defaultSize: defaultFontSizes?.tablet || defaults?.fontSizes?.tablet,
      }),
      getHeadingDesktopFontSize({
        theme,
        headingLevel,
        defaultSize: defaultFontSizes?.desktop || defaults?.fontSizes?.desktop,
      }),
      getHeadingFontSize({
        theme,
        headingLevel,
        defaultSize: defaultFontSizes?.desktop || defaults?.fontSizes?.desktop,
      }),
    ],
    fontWeight: theme?.fontWeights?.headings,
  })
